module.exports = __webpack_public_path__ + "static/img/9areaB_04.c3a8d72.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_04.png
// module id = 1245
// module chunks = 1